import React, { useState } from 'react'
import MainLayout from '../../layouts/MainLayout/MainLayout/MainLayout'
import { useLayoutContext } from '../../utils/LayoutContext/LayoutContext'

import { Route, Routes } from 'react-router-dom'
import mainPageRoutes from '../../navigation/mainPageRoutes'
import { QueryClient, QueryClientProvider } from 'react-query'

export default function MainPage() {
    const {isNoSideBar} = useLayoutContext()
    const routesList = mainPageRoutes
    const [queryClient] = useState(
      () =>
        new QueryClient({
          defaultOptions: { queries: { staleTime: 1000 * 60 * 5 } },
        }),
    );
  return (
    <QueryClientProvider client={queryClient}>
   <MainLayout isNoSideBar={isNoSideBar}>
   <Routes>
   {routesList.map((route, index) => {
            return (

              <Route key={index} path={route.path} element={
              
                <route.main />
         
            } />
            );
          })}
   </Routes>



    </MainLayout>
    </QueryClientProvider>

  )
}

